import React, { useState, useEffect } from 'react';
import { BoxCloseButton, CloseButton, MenuTitle, ContentWrapper } from './styles';
import Menu from '../../../temp/Menu';
import CountrySelector from '../CountrySelector';
import keycodes from '../../../../includes/keycodes';

const LanguageMenu = ({
  handleLanguageMenuVisibility,
  languageMenuOpen,
  initialRegionIndex,
  currentCountry,
  handleMenuByKeyboard,
  menuByKeyboard,
}) => {
  const [visibleMenu, setVisibleMenu] = useState(languageMenuOpen);
  const [closeButton, setCloseButton ] = useState(null);

  useEffect(() => {
    // setTimeout used to handle component closing animation before unmounting
    if (!visibleMenu) {
      setTimeout(() => {
        handleLanguageMenuVisibility(false);
      }, 400);
    }
  }, [visibleMenu, handleLanguageMenuVisibility]);

  useEffect(() => {
    // per accessibility guidelines, if user opened the menu using the keyboard
    // than the Back button should be focused by default
    if(menuByKeyboard.opened && closeButton) {
      closeButton.focus(); 
    }
    return () => setCloseButton(null);
  }, [closeButton, menuByKeyboard]);

  useEffect(() => {
    // function and listener used to close menu with Esc, Space or Enter key
    // sets handleMenuByKeyboard.closed so that LanguageSelector can set focus on country button
    const handleKeydown = event => {
      if (event.keyCode === keycodes.ESCAPE) {
        setVisibleMenu(false);
        handleMenuByKeyboard({ opened: false, closed: true });
      } else if (
        (event.keyCode === keycodes.ENTER || event.keyCode === keycodes.SPACE) &&
        (event.target.dataset.id === 'close-button' ||
          event.target.dataset.id === 'country-button' ||
          event.target.dataset.id === 'language-dropdown-item')
      ) {
        setTimeout(() => {
          setVisibleMenu(false);
          handleMenuByKeyboard({ opened: false, closed: true });
        }, 200);
      }
    };

    document.addEventListener('keydown', handleKeydown);

    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [menuByKeyboard, handleMenuByKeyboard]);

  return (
    <Menu
      handleVisibleMenu={setVisibleMenu}
      visible={visibleMenu}
      disableBackgroundScroll
      backgroundColor="#fff"
      direction="right"
      width="66%"
    >
      <BoxCloseButton>
        <CloseButton
          onClick={() => setVisibleMenu(false)}
          ref={(button) => setCloseButton(button)}
          data-id="close-button"
        >
          <span className="dds__icons">〉</span>
          <span className="text">Back</span>
        </CloseButton>
      </BoxCloseButton>
      <ContentWrapper data-id="content-wrapper">
        <MenuTitle>Please select your location</MenuTitle>
        <CountrySelector
          initialRegionIndex={initialRegionIndex}
          handleMenuVisibility={setVisibleMenu}
          currentCountry={currentCountry}
        />
      </ContentWrapper>
    </Menu>
  );
};

export default LanguageMenu;
